import { render, staticRenderFns } from "./ImageResourceManage.vue?vue&type=template&id=516ac6d8&"
import script from "./ImageResourceManage.vue?vue&type=script&lang=js&"
export * from "./ImageResourceManage.vue?vue&type=script&lang=js&"
import style0 from "./ImageResourceManage.vue?vue&type=style&index=0&id=516ac6d8&lang=scss&"
import style1 from "./ImageResourceManage.vue?vue&type=style&index=1&id=516ac6d8&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516ac6d8')) {
      api.createRecord('516ac6d8', component.options)
    } else {
      api.reload('516ac6d8', component.options)
    }
    module.hot.accept("./ImageResourceManage.vue?vue&type=template&id=516ac6d8&", function () {
      api.rerender('516ac6d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/others/image-resource-manage/ImageResourceManage.vue"
export default component.exports